import SmartEndedScreen from '@/src/auth/smartEndedScreen';

export default SmartEndedScreen;
